import { render, staticRenderFns } from "./searchproject.vue?vue&type=template&id=b30347c0&scoped=true&"
import script from "./searchproject.vue?vue&type=script&lang=js&"
export * from "./searchproject.vue?vue&type=script&lang=js&"
import style0 from "./searchproject.vue?vue&type=style&index=0&id=b30347c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30347c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/buildhome/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VFlex,VIcon,VImg,VLayout,VSpacer})
